(function () {
  var labels = {
    yard: 'Backyard fit',
    anchors: 'Tree setup',
    span: 'Tree distance',
    exactSpan: 'Exact measurement',
    outsideRoute: 'Alternate setup',
    trunkSize: 'Trunk width',
    mountZone: 'Mounting zone',
    noTreeSpace: 'Open space',
    riders: 'Swing size',
    style: 'Play style',
    age: 'Age range',
    ownedKit: 'Your current kit',
    openSpots: 'Open positions',
    spareClips: 'Spare clips',
    accessoryStyle: 'New adventures'
  };

  var productCopy = {
    ninja36: { badge: 'Core system', copy: 'A 36 ft ninja line with ten hanging obstacles for compact and everyday yards.', required: true, maxQty: 1 },
    ninja56: { badge: 'Core system', copy: 'A longer 56 ft ropes-course system with ten varied obstacles for a bigger span.', required: true, maxQty: 1 },
    gym36: { badge: 'Core system', copy: 'Two adjustable swings, gym rings, and a double trapeze on one 36 ft line.', required: true, maxQty: 1 },
    deluxe36: { badge: 'Best-value bundle', copy: 'A 36 ft swing and gymnastics line plus rope ladder and 24 in. saucer swing.', required: true, maxQty: 1 },
    ledRope: { badge: 'Play add-on', copy: 'A light-up climbing and swinging challenge with its own attachment clips.', slotCost: 1, clipNeed: 0, maxQty: 3 },
    ladder: { badge: 'Play add-on', copy: 'A 7 ft climbing ladder with its own attachment clips, so it does not use the kit’s two spares.', slotCost: 1, clipNeed: 0, maxQty: 3 },
    treBoard: { badge: 'Play add-on', copy: 'A surfing-style swing that uses two of the core kit’s spare line clips.', slotCost: 1, clipNeed: 2, maxQty: 1 },
    treSwing: { badge: 'Play add-on', copy: 'A 24 in. explorer swing that uses two of the core kit’s spare line clips.', slotCost: 1, clipNeed: 2, maxQty: 1 },
    branchTreSwing: { badge: 'One-child tree swing', copy: 'A 24 in. swing sized for one young explorer and long afternoons under the canopy.', required: true, maxQty: 1, fallbackTitle: 'TreSwing Explorer' },
    branchDreamcatcher: { badge: 'Room-to-share tree swing', copy: 'A roomy 40 in. swing made for siblings, friends, and one more turn together.', required: true, maxQty: 1, fallbackTitle: '40 Inch Dreamcatcher Tree Swing' },
    treStraps: { badge: 'Required hanging kit', copy: 'Two straps pair the selected swing with the confirmed strong tree branch.', required: true, maxQty: 1, fallbackTitle: 'TreSwing Strap Kit, Set of 2' },
    protectors: { badge: 'Tree-care essential', copy: 'Two heavy-duty wraps help protect tree bark and the line from abrasion.', maxQty: 1 },
    skyExplorer: { badge: 'Single-tree system', copy: 'SkyStand creates a sturdy swing point and pairs it with the 24 in. TreSwing Explorer.', required: true, maxQty: 1 },
    skyDream: { badge: 'Single-tree bundle', copy: 'SkyStand plus the 40 in. Dreamcatcher swing for roomy 360-degree play.', required: true, maxQty: 1 },
    skyStand: { badge: 'Bundle fallback component', copy: 'The branch-free swing support included in the recommended SkyStand bundle.', required: true, maxQty: 1, fallbackTitle: 'SkyStand Swing Support' },
    dreamcatcher: { badge: 'Bundle fallback component', copy: 'The roomy 40 in. swing included in the recommended Dreamcatcher bundle.', required: true, maxQty: 1, fallbackTitle: '40 Inch Dreamcatcher Tree Swing' },
    largeBracket: { badge: 'Required large-tree bracket', copy: 'SKU 340796 replaces the standard SkyStand bracket when the trunk is over 20 in. in diameter or 63 in. around.', required: true, maxQty: 1, sku: '340796' },
    littleCabin: { badge: 'No-tree alternative', copy: 'A freestanding backyard playhouse designed for younger Trelines adventurers.', required: true, maxQty: 1 }
  };

  var BUILDER_VERSION = '2026-08-31.5';
  var EMAIL_BUILD_FIELD_ID = 'custom#trelines_build_url';
  var allowedAnswers = {
    yard: ['compact', 'everyday', 'large'],
    anchors: ['two', 'one', 'branch', 'none'],
    span: ['short', 'long', 'outside'],
    outsideRoute: ['one', 'branch', 'none'],
    trunkSize: ['small', 'standard', 'large'],
    mountZone: ['yes', 'no'],
    noTreeSpace: ['yes', 'no'],
    riders: ['one', 'multiple'],
    style: ['swing', 'ninja', 'mixed'],
    age: ['5-6', '7-8', '9-12'],
    ownedKit: ['36', '56', 'unsure'],
    openSpots: ['1', '2', '3'],
    spareClips: ['none', 'one', 'two', 'unknown'],
    accessoryStyle: ['climb', 'swing', 'mixed']
  };

  function initBuilder(root) {
    if (!root || root.dataset.tlbV2Initialized === 'true') return;
    root.dataset.tlbV2Initialized = 'true';

    var products = {};
    root.querySelectorAll('[data-tlb-product]').forEach(function (node) {
      products[node.dataset.key] = {
        key: node.dataset.key,
        id: Number(node.dataset.id),
        title: node.dataset.title,
        price: Number(node.dataset.price),
        available: node.dataset.available === 'true',
        url: node.dataset.url,
        image: node.dataset.image || ''
      };
    });
    if (!products.largeBracket) {
      products.largeBracket = {
        key: 'largeBracket',
        id: 0,
        title: 'SkyStand Large Bracket',
        price: 5000,
        available: false,
        url: '/products/skystand-large-bracket',
        image: ''
      };
    }

    var currency = root.dataset.currency || 'USD';
    var moneyFormatter;
    try {
      moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });
    } catch (error) {
      moneyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    }

    var state = {
      answers: {},
      mode: 'system',
      current: 0,
      results: false,
      recommendations: [],
      noFit: false,
      capacity: null,
      buildId: '',
      match: null,
      savedItems: null
    };
    var questionWrap = root.querySelector('[data-tlb-questions]');
    var results = root.querySelector('[data-tlb-results]');
    var nav = root.querySelector('[data-tlb-nav]');
    var backButton = root.querySelector('[data-tlb-back]');
    var nextButton = root.querySelector('[data-tlb-next]');
    var addButton = root.querySelector('[data-tlb-add]');
    var cartStatus = root.querySelector('[data-tlb-cart-status]');
    var matchPill = root.querySelector('[data-tlb-match-pill]');
    var spanInput = root.querySelector('[data-tlb-span-input]');
    var saveToggle = root.querySelector('[data-tlb-save-toggle]');
    var savePanel = root.querySelector('[data-tlb-save-panel]');
    var saveStatus = root.querySelector('[data-tlb-save-status]');
    var copyLinkButton = root.querySelector('[data-tlb-copy-link]');
    var emailCapture = root.querySelector('[data-tlb-email-capture]');
    var ownerStart = root.querySelector('[data-tlb-owner-start]');
    var restartButton = root.querySelector('[data-tlb-restart]');
    var helpToggle = root.querySelector('[data-tlb-help-toggle]');
    var helpPanel = root.querySelector('[data-tlb-help-panel]');
    var started = false;
    var campaign = readCampaign();

    state.buildId = createBuildId();

    function formatMoney(cents) {
      return moneyFormatter.format(cents / 100);
    }

    function createBuildId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return 'tlb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }

    function readCampaign() {
      var params = new URLSearchParams(window.location.search);
      var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
      return keys.reduce(function (values, key) {
        var value = params.get(key);
        if (value) values[key] = value.slice(0, 160);
        return values;
      }, {});
    }

    function analyticsAllowed() {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return true;
      try {
        return privacy.analyticsProcessingAllowed();
      } catch (error) {
        return true;
      }
    }

    function selectedItemsPayload() {
      return state.recommendations.filter(function (item) {
        return item.selected && item.product && item.product.available;
      }).map(function (item) {
        return {
          item_id: String(item.product.id),
          item_name: item.product.title,
          item_key: item.key,
          price: item.product.price / 100,
          quantity: item.qty,
          bundle_fallback: item.bundleFallback
        };
      });
    }

    function trackingPayload(extra) {
      var payload = {
        builder_version: BUILDER_VERSION,
        build_id: state.buildId,
        route: effectiveRoute() || 'unselected',
        exact_span_feet: state.answers.exactSpan || null,
        recommendation: state.match ? state.match.title : null,
        bundle_fallback: state.match ? Boolean(state.match.bundleFallback) : false,
        selected_products: selectedItemsPayload()
      };
      Object.keys(campaign).forEach(function (key) { payload[key] = campaign[key]; });
      Object.keys(extra || {}).forEach(function (key) { payload[key] = extra[key]; });
      return payload;
    }

    function track(eventName, extra, ecommerce) {
      if (!analyticsAllowed()) return;
      var payload = trackingPayload(extra);
      window.dataLayer = window.dataLayer || [];
      var dataLayerEvent = { event: eventName, trelines_builder: payload };
      if (ecommerce) dataLayerEvent.ecommerce = ecommerce;
      window.dataLayer.push(dataLayerEvent);
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('lifeisbetteroutside:' + eventName, payload);
        }
      } catch (error) {
        // GTM remains the primary event destination when custom event publishing is unavailable.
      }
    }

    function markStarted() {
      if (started) return;
      started = true;
      track('trelines_builder_started');
    }

    function encodeBuild() {
      var snapshot = {
        v: 1,
        b: state.buildId,
        m: state.mode,
        a: state.answers,
        i: state.recommendations.map(function (item) {
          return { k: item.key, q: item.qty, s: item.selected ? 1 : 0 };
        })
      };
      return window.btoa(JSON.stringify(snapshot)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    }

    function decodeBuild() {
      var encoded = new URLSearchParams(window.location.search).get('tlb_build');
      if (!encoded || encoded.length > 5000) return null;
      try {
        var normalized = encoded.replace(/-/g, '+').replace(/_/g, '/');
        while (normalized.length % 4) normalized += '=';
        var snapshot = JSON.parse(window.atob(normalized));
        if (!snapshot || snapshot.v !== 1 || !snapshot.a || typeof snapshot.a !== 'object') return null;
        var answers = {};
        Object.keys(allowedAnswers).forEach(function (key) {
          if (allowedAnswers[key].indexOf(snapshot.a[key]) !== -1) answers[key] = snapshot.a[key];
        });
        if (snapshot.a.exactSpan !== undefined) {
          var feet = Number(snapshot.a.exactSpan);
          if (Number.isFinite(feet) && feet >= 12 && feet <= 50) answers.exactSpan = feet;
        }
        return {
          answers: answers,
          mode: snapshot.m === 'accessory' ? 'accessory' : 'system',
          buildId: typeof snapshot.b === 'string' && snapshot.b.length <= 80 ? snapshot.b : createBuildId(),
          items: Array.isArray(snapshot.i) ? snapshot.i.slice(0, 20) : []
        };
      } catch (error) {
        return null;
      }
    }

    function restorableUrl() {
      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('tlb_build', encodeBuild());
      return url;
    }

    function shareUrl(medium) {
      var url = restorableUrl();
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (key.indexOf('utm_') === 0 || key === 'gclid' || key === 'fbclid') url.searchParams.delete(key);
      });
      url.searchParams.set('utm_source', 'trelines_builder');
      url.searchParams.set('utm_medium', medium);
      url.searchParams.set('utm_campaign', 'saved_build');
      url.searchParams.set('utm_content', state.buildId);
      return url.toString();
    }

    function findInOpenShadows(node, id) {
      if (!node) return null;
      if (node.shadowRoot) {
        var direct = node.shadowRoot.getElementById(id);
        if (direct) return direct;
        var named = node.shadowRoot.querySelectorAll('[name]');
        for (var namedIndex = 0; namedIndex < named.length; namedIndex += 1) {
          if (named[namedIndex].getAttribute('name') === id) return named[namedIndex];
        }
        var children = node.shadowRoot.querySelectorAll('*');
        for (var index = 0; index < children.length; index += 1) {
          var found = findInOpenShadows(children[index], id);
          if (found) return found;
        }
      }
      return null;
    }

    function setFormValue(input, value) {
      if (!input || input.value === value) return Boolean(input);
      input.value = value;
      try {
        input.dispatchEvent(new InputEvent('input', { bubbles: true, composed: true }));
      } catch (error) {
        input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      }
      input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
      return true;
    }

    function hideBuildField(input) {
      if (!input) return;
      input.setAttribute('tabindex', '-1');
      input.setAttribute('aria-hidden', 'true');
      var fieldRoot = input.getRootNode && input.getRootNode();
      var label = fieldRoot && fieldRoot.querySelector ? fieldRoot.querySelector('label[for="' + EMAIL_BUILD_FIELD_ID + '"]') : null;
      var wrapper = input.closest('[class*="field"], [class*="Field"], shopify-text-field') || input.parentElement;
      var form = input.closest('form');
      var formHeader = form && form.parentElement ? form.parentElement.querySelector('section[class*="formHeader"]') : null;
      input.hidden = true;
      input.style.setProperty('display', 'none', 'important');
      if (label) {
        label.hidden = true;
        label.style.setProperty('display', 'none', 'important');
      }
      if (wrapper) {
        wrapper.hidden = true;
        wrapper.style.setProperty('display', 'none', 'important');
      }
      if (formHeader) {
        formHeader.hidden = true;
        formHeader.style.setProperty('display', 'none', 'important');
      }
    }

    function syncEmailBuild() {
      if (!state.results || !emailCapture) return false;
      var host = emailCapture.querySelector('shopify-forms-embed');
      var input = findInOpenShadows(host, EMAIL_BUILD_FIELD_ID);
      if (!input) return false;
      setFormValue(input, shareUrl('email'));
      hideBuildField(input);
      return true;
    }

    function prepareEmailCapture() {
      if (syncEmailBuild() || !emailCapture) return;
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        if (syncEmailBuild() || attempts >= 60) window.clearInterval(timer);
      }, 250);
    }

    function syncHelpBuild() {
      var input = root.querySelector('[data-tlb-help-build-url]');
      if (!input) return false;
      var url = shareUrl('support');
      input.value = url;
      input.textContent = url;
      return input.value === url;
    }

    function prepareHelpForm() {
      if (syncHelpBuild()) return;
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        if (syncHelpBuild() || attempts >= 40) window.clearInterval(timer);
      }, 100);
    }

    function updateShareActions() {
      if (!state.results) return;
      syncEmailBuild();
      syncHelpBuild();
    }

    function trackedProductUrl(product, itemKey) {
      try {
        var url = new URL(product.url, window.location.origin);
        url.searchParams.set('utm_source', 'trelines_builder');
        url.searchParams.set('utm_medium', 'builder');
        url.searchParams.set('utm_campaign', 'product_recommendation');
        url.searchParams.set('utm_content', itemKey);
        return url.toString();
      } catch (error) {
        return product.url;
      }
    }

    function cartProperties() {
      var source = campaign.utm_source || 'direct';
      var medium = campaign.utm_medium || 'none';
      var campaignName = campaign.utm_campaign || 'none';
      var properties = {
        '_Trelines build ID': state.buildId,
        '_Trelines route': effectiveRoute() || 'unknown',
        '_Trelines builder version': BUILDER_VERSION,
        '_Trelines recommendation': state.match ? state.match.title : 'Trelines build',
        '_Trelines campaign': source + ' / ' + medium + ' / ' + campaignName
      };
      if (state.answers.exactSpan) properties['_Trelines measured span'] = state.answers.exactSpan + ' ft';
      return properties;
    }

    function copyText(value) {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        return navigator.clipboard.writeText(value);
      }
      return new Promise(function (resolve, reject) {
        var input = document.createElement('textarea');
        input.value = value;
        input.setAttribute('readonly', 'readonly');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand('copy') ? resolve() : reject(new Error('Copy failed'));
        } catch (error) {
          reject(error);
        }
        input.remove();
      });
    }

    function effectiveRoute() {
      if (state.mode === 'accessory') return 'accessory';
      if (state.answers.anchors === 'two' && state.answers.span === 'outside') {
        return state.answers.outsideRoute || '';
      }
      return state.answers.anchors || '';
    }

    function getFlow() {
      var a = state.answers;
      if (state.mode === 'accessory') return ['ownedKit', 'openSpots', 'spareClips', 'accessoryStyle'];
      var flow = ['yard', 'anchors'];
      var route = effectiveRoute();

      if (a.anchors === 'two') {
        flow.push('span');
        if (a.span === 'short' || a.span === 'long') {
          flow.push('exactSpan', 'style', 'age');
          return flow;
        }
        if (a.span === 'outside') flow.push('outsideRoute');
      }

      if (route === 'one') {
        flow.push('trunkSize');
        if (a.trunkSize === 'standard' || a.trunkSize === 'large') {
          flow.push('mountZone');
          if (a.mountZone === 'yes') flow.push('style', 'age');
        }
        return flow;
      }

      if (route === 'none') {
        flow.push('noTreeSpace', 'age');
        return flow;
      }

      if (route === 'branch') {
        flow.push('riders');
        return flow;
      }

      return flow;
    }

    function spanBounds() {
      return state.answers.span === 'long' ? { min: 31, max: 50 } : { min: 12, max: 30 };
    }

    function capacityForSpan(feet) {
      var cap = Math.floor((Number(feet) - 12) / 6);
      var maximum = state.answers.span === 'long' ? 5 : 3;
      return Math.max(0, Math.min(maximum, cap));
    }

    function isAnswered(key) {
      if (key === 'exactSpan') {
        var bounds = spanBounds();
        var feet = Number(state.answers.exactSpan);
        return Number.isFinite(feet) && feet >= bounds.min && feet <= bounds.max;
      }
      return Boolean(state.answers[key]);
    }

    function answerLabel(key) {
      if (key === 'exactSpan') return state.answers.exactSpan ? state.answers.exactSpan + ' ft exact' : 'Not answered';
      var panel = root.querySelector('[data-tlb-question="' + key + '"]');
      var answer = state.answers[key];
      var option = panel && answer ? panel.querySelector('[data-tlb-answer="' + answer + '"]') : null;
      return option ? option.dataset.label : 'Not answered';
    }

    function renderSummary() {
      var a = state.answers;
      var route = effectiveRoute();
      var summaryLabels;
      var pairs;

      if (state.mode === 'accessory') {
        summaryLabels = {
          yard: 'Current kit',
          anchors: 'Open spots',
          fit: 'Spare clips',
          style: 'Play goal',
          age: 'Plan type'
        };
        pairs = {
          yard: answerLabel('ownedKit'),
          anchors: answerLabel('openSpots'),
          fit: answerLabel('spareClips'),
          style: answerLabel('accessoryStyle'),
          age: 'Accessories only'
        };
      } else {
        summaryLabels = {
          yard: 'Backyard',
          anchors: 'Tree setup',
          fit: 'Fit detail',
          style: 'Play style',
          age: 'Age band'
        };
      var anchorSummary = answerLabel('anchors');
      var fitSummary = 'Not answered';
      var styleSummary = answerLabel('style');

      if (a.anchors === 'two' && a.span === 'outside' && route === 'one') anchorSummary = 'One-tree alternative';
      if (a.anchors === 'two' && a.span === 'outside' && route === 'branch') anchorSummary = 'Strong-branch swing alternative';
      if (a.anchors === 'two' && a.span === 'outside' && route === 'none') anchorSummary = 'No-tree alternative';
      if (route === 'two') fitSummary = a.exactSpan ? answerLabel('span') + ' · ' + answerLabel('exactSpan') : answerLabel('span');
      if (route === 'one') fitSummary = answerLabel('trunkSize') + (a.mountZone ? ' · ' + answerLabel('mountZone') : '');
      if (route === 'branch') fitSummary = answerLabel('riders');
      if (route === 'none') fitSummary = answerLabel('noTreeSpace');
      if (route === 'none') styleSummary = 'No-tree route';
      if (route === 'branch') styleSummary = 'Branch-hung tree swing';
      if (route === 'one' && a.mountZone !== 'yes') styleSummary = 'Not needed for fit check';

        pairs = {
          yard: answerLabel('yard'),
          anchors: anchorSummary,
          fit: fitSummary,
          style: styleSummary,
          age: route === 'branch' ? 'Not needed for this swing' : answerLabel('age')
        };
      }
      Object.keys(summaryLabels).forEach(function (key) {
        var label = root.querySelector('[data-tlb-summary-label="' + key + '"]');
        if (label) label.textContent = summaryLabels[key];
      });
      Object.keys(pairs).forEach(function (key) {
        var target = root.querySelector('[data-tlb-summary="' + key + '"]');
        if (target) target.textContent = pairs[key];
      });
    }

    function syncExactSpan() {
      var bounds = spanBounds();
      var help = root.querySelector('[data-tlb-span-help]');
      var scale = root.querySelector('[data-tlb-span-scale]');
      var wrap = spanInput.closest('.tlb-exact-span');
      spanInput.min = String(bounds.min);
      spanInput.max = String(bounds.max);
      spanInput.placeholder = String(bounds.min);
      scale.textContent = bounds.min + '–' + bounds.max + ' ft';
      if (state.answers.exactSpan !== undefined) spanInput.value = state.answers.exactSpan;

      var raw = spanInput.value.trim();
      var feet = Number(raw);
      var valid = raw !== '' && Number.isFinite(feet) && feet >= bounds.min && feet <= bounds.max;
      wrap.dataset.invalid = raw !== '' && !valid ? 'true' : 'false';
      if (valid) {
        var slots = capacityForSpan(feet);
        help.textContent = slots === 0
          ? 'Core kit only at this distance—no additional play positions.'
          : 'This distance supports up to ' + slots + ' additional play position' + (slots === 1 ? '.' : 's.');
      } else {
        help.textContent = 'Enter a measurement from ' + bounds.min + ' to ' + bounds.max + ' feet.';
      }
    }

    function syncNavigation() {
      var flow = getFlow();
      state.current = Math.min(state.current, flow.length - 1);
      var key = flow[state.current];
      nextButton.disabled = !isAnswered(key);
      root.querySelector('[data-tlb-next-label]').textContent = state.current === flow.length - 1 ? 'See my system' : 'Next question';
      backButton.disabled = state.current === 0 && state.mode !== 'accessory';
      var displayTotal = state.mode === 'accessory' ? flow.length : (state.answers.anchors ? flow.length : 6);
      root.querySelector('[data-tlb-step-label]').textContent = 'Step ' + (state.current + 1) + ' of ' + displayTotal;
      root.querySelector('[data-tlb-progress-label]').textContent = labels[key];
      root.querySelector('[data-tlb-progress-bar]').style.width = (((state.current + 1) / displayTotal) * 100) + '%';
    }

    function renderQuestion() {
      var flow = getFlow();
      state.current = Math.min(state.current, flow.length - 1);
      var key = flow[state.current];
      root.querySelectorAll('[data-tlb-question]').forEach(function (panel) {
        panel.hidden = panel.dataset.tlbQuestion !== key;
      });
      questionWrap.hidden = false;
      results.hidden = true;
      nav.hidden = false;
      var panel = root.querySelector('[data-tlb-question="' + key + '"]');
      panel.querySelectorAll('[data-tlb-answer]').forEach(function (option) {
        option.setAttribute('aria-pressed', option.dataset.tlbAnswer === state.answers[key] ? 'true' : 'false');
      });
      if (key === 'exactSpan') syncExactSpan();
      syncNavigation();
      renderSummary();
      root.dataset.tlbMode = state.mode;
      if (ownerStart) ownerStart.hidden = state.mode !== 'system' || state.current !== 0 || state.results;
    }

    function lineRecommendation() {
      var a = state.answers;
      var feet = Number(a.exactSpan);
      var slots = capacityForSpan(feet);
      var core = a.span === 'long' ? 'ninja56' : (a.style === 'swing' ? 'gym36' : 'ninja36');
      var priorities = {
        swing: ['treSwing', 'ledRope', 'ladder', 'treBoard'],
        ninja: ['ladder', 'ledRope', 'treBoard', 'treSwing'],
        mixed: ['ladder', 'treBoard', 'ledRope', 'treSwing']
      };
      var keys = [core, 'protectors'];
      var clipsUsed = 0;
      var availableAddOns = (priorities[a.style] || priorities.mixed).filter(function (key) {
        return products[key] && products[key].available;
      });
      availableAddOns.some(function (key) {
        if (keys.length - 2 >= slots) return true;
        var clipNeed = productCopy[key].clipNeed || 0;
        if (clipsUsed + clipNeed > 2) return false;
        keys.push(key);
        clipsUsed += clipNeed;
        return false;
      });

      var title = a.span === 'long' ? '56 ft Trelines system' : '36 ft Trelines system';
      if (slots > 0) title += ' + ' + Math.min(slots, keys.length - 2) + ' fitted extra' + (Math.min(slots, keys.length - 2) === 1 ? '' : 's');
      var reason = slots === 0
        ? 'At ' + feet + ' ft, start with one core kit. The measured span leaves no safe planning room for added obstacles or swings.'
        : 'Your ' + feet + ' ft span supports one core kit plus up to ' + slots + ' extra play position' + (slots === 1 ? '' : 's') + '. Items marked “clips included” preserve the two spare clips supplied with the kit.';
      return {
        items: keys.map(function (key) { return { key: key }; }),
        title: title,
        reason: reason,
        noFit: false,
        bundleFallback: false,
        capacity: { feet: feet, slots: slots, clipSupply: 2 }
      };
    }

    function accessoryRecommendation() {
      var a = state.answers;
      var slots = Math.max(1, Math.min(3, Number(a.openSpots) || 1));
      var clipSupply = a.spareClips === 'two' ? 2 : (a.spareClips === 'one' ? 1 : 0);
      var priorities = {
        climb: ['ladder', 'ledRope', 'treBoard', 'treSwing'],
        swing: ['treSwing', 'treBoard', 'ledRope', 'ladder'],
        mixed: ['ladder', 'treBoard', 'ledRope', 'treSwing']
      };
      var keys = [];
      var clipsUsed = 0;

      (priorities[a.accessoryStyle] || priorities.mixed).some(function (key) {
        if (keys.length >= slots) return true;
        if (!products[key] || !products[key].available) return false;
        var clipNeed = productCopy[key].clipNeed || 0;
        if (clipsUsed + clipNeed > clipSupply) return false;
        keys.push(key);
        clipsUsed += clipNeed;
        return false;
      });

      var kitLabel = a.ownedKit === '36' ? '36 ft line' : (a.ownedKit === '56' ? '56 ft line' : 'Trelines line');
      var count = keys.length;
      var title = count + ' new adventure' + (count === 1 ? '' : 's') + ' for your ' + kitLabel;
      var reason = 'Your existing ' + kitLabel + ' has room for ' + slots + ' more play position' + (slots === 1 ? '' : 's') + '. ';

      if (a.spareClips === 'unknown') {
        reason += 'Since the spare clip count is unknown, this plan favors accessories that include their own clips.';
      } else if (clipSupply < 2) {
        reason += 'With fewer than two spare clips, this plan uses accessories that bring their own.';
      } else {
        reason += 'The mix stays within the two spare clips you confirmed.';
      }

      return {
        items: keys.map(function (key) { return { key: key, required: false }; }),
        title: title,
        reason: reason,
        noFit: count === 0,
        bundleFallback: false,
        capacity: { accessory: true, slots: slots, clipSupply: clipSupply, clipUnknown: a.spareClips === 'unknown' }
      };
    }

    function resolveBundle(bundleKey, componentKeys) {
      var bundle = products[bundleKey];
      if (bundle && bundle.available) {
        return { items: [{ key: bundleKey, required: true }], usedFallback: false };
      }
      return {
        items: componentKeys.map(function (key) {
          return { key: key, required: true, bundleFallback: true };
        }),
        usedFallback: true
      };
    }

    function productForKey(key) {
      if (products[key]) return products[key];
      var copy = productCopy[key] || {};
      return {
        key: key,
        id: 0,
        title: copy.fallbackTitle || 'Required Trelines component',
        price: 0,
        available: false,
        url: root.dataset.collectionUrl,
        image: ''
      };
    }

    function recommendation() {
      var a = state.answers;
      var route = effectiveRoute();
      var items = [];
      var title = '';
      var reason = '';
      var noFit = false;
      var bundleFallback = false;

      if (route === 'accessory') return accessoryRecommendation();
      if (route === 'two') return lineRecommendation();

      if (route === 'branch') {
        items = [
          { key: a.riders === 'multiple' ? 'branchDreamcatcher' : 'branchTreSwing', required: true },
          { key: 'treStraps', required: true }
        ];
        if (a.riders === 'multiple') {
          title = 'Dreamcatcher Swing + Tree Straps';
          reason = 'Room to share under the canopy. The 40 in. Dreamcatcher is paired with the two-strap hanging kit for your confirmed strong branch.';
        } else {
          title = 'TreSwing Explorer + Tree Straps';
          reason = 'One seat, one strong branch, and a whole lot of afternoons outside. The 24 in. TreSwing is paired with the two-strap hanging kit.';
        }
      } else if (route === 'one' && a.trunkSize === 'small') {
        noFit = true;
        title = 'This trunk is below the SkyStand minimum';
        reason = 'SkyStand requires a healthy trunk at least 12 in. in diameter or 37 in. in circumference. Choose another mature tree before ordering.';
      } else if (route === 'one' && a.mountZone !== 'yes') {
        noFit = true;
        title = 'Confirm the mounting zone first';
        reason = 'The bracket needs at least 24 in. of straight, clear trunk at a minimum mounting height of 8 ft. Confirm both measurements before ordering.';
      } else if (route === 'none' && (a.noTreeSpace !== 'yes' || a.age === '9-12')) {
        noFit = true;
        title = 'Your space needs a custom fit';
        reason = a.age === '9-12'
          ? 'The current no-tree Trelines alternative is designed for younger kids. A healthy tree anchor is needed for the adventure systems recommended for ages 9–12.'
          : 'The freestanding playhouse needs a clear 8 × 8 ft. play zone. Measure the space first, then return when you can confirm the footprint.';
      } else if (route === 'none') {
        items = [{ key: 'littleCabin' }];
        title = 'My First Little Cabin';
        reason = 'No trees required. This freestanding Trelines playhouse gives ages 5–8 an imaginative backyard base that fits the open play zone you selected.';
      } else if (route === 'one') {
        var bundleMatch;
        if (a.style === 'swing' && (a.age === '5-6' || a.yard === 'compact')) {
          bundleMatch = resolveBundle('skyExplorer', ['skyStand', 'treSwing']);
          title = 'SkyStand + TreSwing Explorer';
          reason = 'A compact single-tree setup with a 24 in. swing and no branch required.';
        } else if (a.style === 'ninja') {
          bundleMatch = resolveBundle('skyExplorer', ['skyStand', 'treSwing']);
          title = 'The safest single-tree match';
          reason = 'Ninja lines need two suitable anchors, so this one-tree space is better matched to SkyStand and the TreSwing Explorer.';
        } else {
          bundleMatch = resolveBundle('skyDream', ['skyStand', 'dreamcatcher']);
          title = 'SkyStand + Dreamcatcher Swing';
          reason = 'The single-tree bundle creates a branch-free 360-degree swing zone and makes the most of the confirmed mature trunk.';
        }
        items = bundleMatch.items;
        bundleFallback = bundleMatch.usedFallback;
        if (bundleFallback) {
          reason += ' The bundle is currently unavailable, so the same setup is recommended as individually stocked components.';
        }
        if (a.trunkSize === 'large') {
          items.push({ key: 'largeBracket', required: true });
          reason += ' Because the trunk is over 20 in. across or 63 in. around, SKU 340796 is included as the required replacement bracket.';
        } else {
          reason += ' The standard bracket fits the confirmed 12–20 in. diameter range.';
        }
        items.push({ key: 'protectors' });
        reason += ' Tree protectors are included to help reduce bark and line abrasion.';
      } else {
        noFit = true;
        title = 'Choose an alternate setup';
        reason = 'Select either the single-tree or no-tree route so the builder can complete the fit check.';
      }

      return { items: items, title: title, reason: reason, noFit: noFit, bundleFallback: bundleFallback, capacity: null };
    }

    function usage(excludeItem) {
      return state.recommendations.reduce(function (total, item) {
        if (item === excludeItem || !item.selected || !item.product || !item.product.available) return total;
        var copy = productCopy[item.key] || {};
        total.slots += (copy.slotCost || 0) * item.qty;
        total.clips += (copy.clipNeed || 0) * item.qty;
        return total;
      }, { slots: 0, clips: 0 });
    }

    function canSetItem(item, quantity) {
      if (!state.capacity) return quantity <= (productCopy[item.key].maxQty || 1);
      var copy = productCopy[item.key] || {};
      var used = usage(item);
      return quantity <= (copy.maxQty || 1)
        && used.slots + ((copy.slotCost || 0) * quantity) <= state.capacity.slots
        && used.clips + ((copy.clipNeed || 0) * quantity) <= state.capacity.clipSupply;
    }

    function selectedTotal() {
      return state.recommendations.reduce(function (sum, item) {
        if (!item.selected || !item.product || !item.product.available) return sum;
        return sum + (item.product.price * item.qty);
      }, 0);
    }

    function requiredUnavailable() {
      return state.recommendations.some(function (item) {
        return item.required && (!item.product || !item.product.available);
      });
    }

    function applySavedItems() {
      if (!Array.isArray(state.savedItems) || !state.savedItems.length) return;
      var savedByKey = state.savedItems.reduce(function (map, item) {
        if (item && typeof item.k === 'string') map[item.k] = item;
        return map;
      }, {});
      state.recommendations.forEach(function (item) {
        var saved = savedByKey[item.key];
        if (!saved) return;
        var maximum = (productCopy[item.key] && productCopy[item.key].maxQty) || 1;
        var quantity = Number(saved.q);
        item.qty = Number.isFinite(quantity) ? Math.max(1, Math.min(maximum, Math.floor(quantity))) : 1;
        if (!item.required) item.selected = saved.s === 1;
      });
      state.recommendations.forEach(function (item) {
        if (!item.required && item.selected && !canSetItem(item, item.qty)) {
          item.selected = false;
          item.qty = 1;
        }
      });
      state.savedItems = null;
    }

    function renderFitSummary() {
      var fit = root.querySelector('[data-tlb-fit-summary]');
      if (!state.capacity || state.noFit) {
        fit.hidden = true;
        return;
      }
      var used = usage();
      fit.hidden = false;
      if (state.capacity.accessory) {
        root.querySelector('[data-tlb-fit-label-distance]').textContent = 'Open positions';
        root.querySelector('[data-tlb-fit-label-slots]').textContent = 'Positions planned';
        root.querySelector('[data-tlb-fit-label-clips]').textContent = 'Spare clips';
        root.querySelector('[data-tlb-fit-distance]').textContent = state.capacity.slots + ' available';
        root.querySelector('[data-tlb-fit-slots]').textContent = used.slots + ' of ' + state.capacity.slots + ' planned';
        root.querySelector('[data-tlb-fit-clips]').textContent = state.capacity.clipUnknown
          ? 'Not counted'
          : used.clips + ' of ' + state.capacity.clipSupply + ' used';
      } else {
        root.querySelector('[data-tlb-fit-label-distance]').textContent = 'Measured span';
        root.querySelector('[data-tlb-fit-label-slots]').textContent = 'Extra play positions';
        root.querySelector('[data-tlb-fit-label-clips]').textContent = 'Spare kit clips';
        root.querySelector('[data-tlb-fit-distance]').textContent = state.capacity.feet + ' ft';
        root.querySelector('[data-tlb-fit-slots]').textContent = state.capacity.slots === 0
          ? 'Core kit only'
          : used.slots + ' of ' + state.capacity.slots + ' planned';
        root.querySelector('[data-tlb-fit-clips]').textContent = used.clips + ' of ' + state.capacity.clipSupply + ' used';
      }
    }

    function renderTotal() {
      var total = selectedTotal();
      var selected = state.recommendations.filter(function (item) {
        return item.selected && item.product && item.product.available;
      });
      var blocked = requiredUnavailable();
      root.querySelector('[data-tlb-total]').textContent = formatMoney(total);
      if (state.noFit) root.querySelector('[data-tlb-side-total]').textContent = 'Fit check needed';
      else if (blocked) root.querySelector('[data-tlb-side-total]').textContent = formatMoney(total) + ' + unavailable item';
      else root.querySelector('[data-tlb-side-total]').textContent = formatMoney(total);
      addButton.disabled = state.noFit || blocked || selected.length === 0;
      if (blocked) root.querySelector('[data-tlb-add-label]').textContent = 'Required item currently unavailable';
      else if (state.noFit) root.querySelector('[data-tlb-add-label]').textContent = 'Fit check needed';
      else if (selected.length === 0) root.querySelector('[data-tlb-add-label]').textContent = state.mode === 'accessory' ? 'Choose at least one accessory' : 'Choose a system to continue';
      else root.querySelector('[data-tlb-add-label]').textContent = (state.mode === 'accessory' ? 'Add accessories to cart · ' : 'Add system to cart · ') + formatMoney(total);
      renderFitSummary();
      syncEmailBuild();
    }

    function productCard(item, index) {
      var product = item.product;
      var copy = productCopy[item.key] || { badge: 'Recommended', copy: '', maxQty: 1 };
      var article = document.createElement('article');
      article.className = 'tlb-product';
      article.dataset.index = String(index);
      article.dataset.selected = item.selected ? 'true' : 'false';
      article.dataset.available = product.available ? 'true' : 'false';

      var image = document.createElement('div');
      image.className = 'tlb-product__image';
      if (product.image) {
        var img = document.createElement('img');
        img.src = product.image;
        img.alt = product.title;
        img.loading = 'lazy';
        image.appendChild(img);
      } else {
        image.textContent = copy.sku ? 'SKU ' + copy.sku : 'Trelines';
      }

      var productBody = document.createElement('div');
      productBody.className = 'tlb-product__copy';
      var badge = document.createElement('span');
      badge.className = 'tlb-product__badge';
      badge.textContent = item.bundleFallback ? 'Bundle fallback component' : copy.badge;
      var title = document.createElement('h3');
      var link = document.createElement('a');
      link.href = trackedProductUrl(product, item.key);
      link.textContent = product.title;
      title.appendChild(link);
      var description = document.createElement('p');
      description.textContent = copy.copy;
      productBody.appendChild(badge);
      productBody.appendChild(title);
      productBody.appendChild(description);

      if (copy.slotCost || copy.clipNeed !== undefined || copy.sku) {
        var meta = document.createElement('div');
        meta.className = 'tlb-product__meta';
        if (copy.slotCost) {
          var slot = document.createElement('span');
          slot.textContent = copy.slotCost + ' play position';
          meta.appendChild(slot);
        }
        if (copy.clipNeed !== undefined) {
          var clips = document.createElement('span');
          clips.textContent = copy.clipNeed === 0 ? 'Clips included' : 'Uses ' + copy.clipNeed + ' kit clips';
          if (copy.clipNeed > 0) clips.dataset.tone = 'warn';
          meta.appendChild(clips);
        }
        if (copy.sku) {
          var sku = document.createElement('span');
          sku.textContent = 'SKU ' + copy.sku;
          sku.dataset.tone = 'warn';
          meta.appendChild(sku);
        }
        productBody.appendChild(meta);
      }

      var controls = document.createElement('div');
      controls.className = 'tlb-product__controls';
      var price = document.createElement('span');
      price.className = 'tlb-product__price';
      price.textContent = product.available ? formatMoney(product.price * item.qty) : 'Unavailable';
      controls.appendChild(price);

      if (product.available && (copy.maxQty || 1) > 1) {
        var quantity = document.createElement('div');
        quantity.className = 'tlb-quantity';
        quantity.setAttribute('aria-label', 'Quantity for ' + product.title);
        var minusDisabled = item.qty <= 1 ? ' disabled' : '';
        var plusDisabled = canSetItem(item, item.qty + 1) ? '' : ' disabled';
        quantity.innerHTML = '<button type="button" data-tlb-qty="minus" aria-label="Decrease quantity"' + minusDisabled + '>−</button><span>' + item.qty + '</span><button type="button" data-tlb-qty="plus" aria-label="Increase quantity"' + plusDisabled + '>+</button>';
        controls.appendChild(quantity);
      }

      var toggle = document.createElement('label');
      toggle.className = 'tlb-product__toggle';
      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.checked = item.selected;
      checkbox.disabled = item.required || !product.available;
      checkbox.dataset.tlbToggle = '';
      toggle.appendChild(checkbox);
      toggle.appendChild(document.createTextNode(item.required ? ' Required' : (product.available ? ' Include' : ' Unavailable')));
      controls.appendChild(toggle);

      article.appendChild(image);
      article.appendChild(productBody);
      article.appendChild(controls);
      return article;
    }

    function renderRecommendationList() {
      var list = root.querySelector('[data-tlb-result-list]');
      list.replaceChildren();
      if (state.noFit) {
        var noFit = document.createElement('div');
        noFit.className = 'tlb-no-fit';
        var heading = document.createElement('h3');
        heading.textContent = 'No product added yet';
        var copy = document.createElement('p');
        copy.textContent = 'Safety and fit come before the cart. Update the flagged answer or browse the full Trelines collection for another starting point.';
        var browse = document.createElement('a');
        browse.href = root.dataset.collectionUrl;
        browse.textContent = 'Browse all Trelines products →';
        noFit.appendChild(heading);
        noFit.appendChild(copy);
        noFit.appendChild(browse);
        list.appendChild(noFit);
      } else {
        state.recommendations.forEach(function (item, index) {
          list.appendChild(productCard(item, index));
        });
      }
      root.querySelector('[data-tlb-checkout]').hidden = state.noFit;
      root.querySelector('[data-tlb-safety]').hidden = false;
      renderTotal();
      updateShareActions();
    }

    function showResults() {
      var match = recommendation();
      state.results = true;
      state.noFit = match.noFit;
      state.capacity = match.capacity;
      state.match = match;
      state.recommendations = match.items.map(function (item) {
        var copy = productCopy[item.key] || {};
        return {
          key: item.key,
          product: productForKey(item.key),
          qty: item.qty || 1,
          selected: true,
          required: item.required === undefined ? Boolean(copy.required) : Boolean(item.required),
          bundleFallback: Boolean(item.bundleFallback)
        };
      }).filter(function (item) {
        return item.product.available || item.required;
      });
      applySavedItems();
      matchPill.textContent = state.mode === 'accessory'
        ? 'Accessory-only plan'
        : (match.bundleFallback ? 'Bundle fallback · same setup' : 'Your best-fit system');
      root.querySelector('[data-tlb-result-title]').textContent = match.title;
      root.querySelector('[data-tlb-result-reason]').textContent = match.reason;
      questionWrap.hidden = true;
      results.hidden = false;
      nav.hidden = true;
      if (ownerStart) ownerStart.hidden = true;
      root.querySelector('[data-tlb-step-label]').textContent = 'Complete';
      root.querySelector('[data-tlb-progress-label]').textContent = 'Your recommendation';
      root.querySelector('[data-tlb-progress-bar]').style.width = '100%';
      cartStatus.textContent = requiredUnavailable()
        ? 'A required item is currently unavailable, so the builder will not add an incomplete system.'
        : (match.bundleFallback ? 'The preferred bundle is unavailable. The complete in-stock setup is shown as individual items.' : '');
      renderRecommendationList();
      renderSummary();
      updateShareActions();
      track('trelines_recommendation_viewed', {
        recommendation_value: selectedTotal() / 100,
        currency: currency,
        no_fit: state.noFit
      });
    }

    function clearAfter(key) {
      var groups = {
        anchors: ['span', 'exactSpan', 'outsideRoute', 'trunkSize', 'mountZone', 'noTreeSpace', 'riders', 'style', 'age'],
        span: ['exactSpan', 'outsideRoute', 'trunkSize', 'mountZone', 'noTreeSpace', 'riders', 'style', 'age'],
        outsideRoute: ['trunkSize', 'mountZone', 'noTreeSpace', 'riders', 'style', 'age'],
        trunkSize: ['mountZone', 'style', 'age'],
        mountZone: ['style', 'age'],
        noTreeSpace: ['age'],
        ownedKit: ['openSpots', 'spareClips', 'accessoryStyle'],
        openSpots: ['spareClips', 'accessoryStyle'],
        spareClips: ['accessoryStyle']
      };
      (groups[key] || []).forEach(function (answer) { delete state.answers[answer]; });
      if (key === 'span') spanInput.value = '';
    }

    if (ownerStart) ownerStart.addEventListener('click', function () {
      state.mode = 'accessory';
      state.answers = {};
      state.current = 0;
      state.results = false;
      state.savedItems = null;
      state.capacity = null;
      root.querySelector('[data-tlb-side-total]').textContent = '—';
      savePanel.hidden = true;
      saveToggle.setAttribute('aria-expanded', 'false');
      markStarted();
      renderQuestion();
      track('trelines_accessory_builder_started');
      var app = root.querySelector('.tlb-app');
      if (app && typeof app.scrollIntoView === 'function') app.scrollIntoView({ block: 'start' });
    });

    questionWrap.addEventListener('click', function (event) {
      var option = event.target.closest('[data-tlb-answer]');
      if (!option) return;
      markStarted();
      var panel = option.closest('[data-tlb-question]');
      var key = panel.dataset.tlbQuestion;
      if (state.answers[key] !== option.dataset.tlbAnswer) clearAfter(key);
      state.answers[key] = option.dataset.tlbAnswer;
      panel.querySelectorAll('[data-tlb-answer]').forEach(function (button) {
        button.setAttribute('aria-pressed', button === option ? 'true' : 'false');
      });
      syncNavigation();
      renderSummary();
    });

    spanInput.addEventListener('input', function () {
      markStarted();
      var bounds = spanBounds();
      var value = Number(spanInput.value);
      if (spanInput.value.trim() !== '' && Number.isFinite(value) && value >= bounds.min && value <= bounds.max) {
        state.answers.exactSpan = value;
      } else {
        delete state.answers.exactSpan;
      }
      syncExactSpan();
      syncNavigation();
      renderSummary();
    });

    nextButton.addEventListener('click', function () {
      var flow = getFlow();
      var key = flow[state.current];
      if (!isAnswered(key)) return;
      track('trelines_builder_step_completed', {
        step_key: key,
        step_number: state.current + 1,
        answer: key === 'exactSpan' ? state.answers.exactSpan : state.answers[key]
      });
      if (state.current >= flow.length - 1) showResults();
      else {
        state.current += 1;
        renderQuestion();
      }
    });

    backButton.addEventListener('click', function () {
      if (state.current > 0) {
        state.current -= 1;
        renderQuestion();
      } else if (state.mode === 'accessory') {
        state.mode = 'system';
        state.answers = {};
        state.current = 0;
        state.capacity = null;
        renderQuestion();
      }
    });

    root.querySelector('[data-tlb-edit]').addEventListener('click', function () {
      state.results = false;
      state.current = Math.max(0, getFlow().length - 1);
      root.querySelector('[data-tlb-side-total]').textContent = '—';
      savePanel.hidden = true;
      saveToggle.setAttribute('aria-expanded', 'false');
      helpPanel.hidden = true;
      helpToggle.setAttribute('aria-expanded', 'false');
      renderQuestion();
    });

    restartButton.addEventListener('click', function () {
      var previousRoute = effectiveRoute();
      track('trelines_builder_restarted', { previous_route: previousRoute });
      state.mode = 'system';
      state.answers = {};
      state.current = 0;
      state.results = false;
      state.recommendations = [];
      state.noFit = false;
      state.capacity = null;
      state.match = null;
      state.savedItems = null;
      state.buildId = createBuildId();
      started = false;
      spanInput.value = '';
      cartStatus.textContent = '';
      saveStatus.textContent = '';
      savePanel.hidden = true;
      saveToggle.setAttribute('aria-expanded', 'false');
      helpPanel.hidden = true;
      helpToggle.setAttribute('aria-expanded', 'false');
      root.querySelector('[data-tlb-side-total]').textContent = '—';
      var cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('tlb_build');
      window.history.replaceState({}, '', cleanUrl.toString());
      renderQuestion();
      var app = root.querySelector('.tlb-app');
      if (app && typeof app.scrollIntoView === 'function') app.scrollIntoView({ block: 'start' });
    });

    saveToggle.addEventListener('click', function () {
      var opening = savePanel.hidden;
      savePanel.hidden = !opening;
      saveToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      saveStatus.textContent = '';
      if (opening) {
        prepareEmailCapture();
        track('trelines_save_panel_opened');
      }
    });

    helpToggle.addEventListener('click', function () {
      var opening = helpPanel.hidden;
      helpPanel.hidden = !opening;
      helpToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) {
        prepareHelpForm();
        track('trelines_help_form_opened');
      }
    });

    helpPanel.addEventListener('submit', function (event) {
      if (!event.target.matches('form')) return;
      syncHelpBuild();
      track('trelines_help_requested');
    });

    if (root.querySelector('[data-tlb-help-success]')) {
      helpPanel.hidden = false;
      helpToggle.setAttribute('aria-expanded', 'true');
    }

    copyLinkButton.addEventListener('click', function () {
      var url = shareUrl('share');
      copyLinkButton.disabled = true;
      copyText(url).then(function () {
        saveStatus.textContent = 'Link copied. This build is ready to share.';
        track('trelines_build_saved', { save_method: 'copy_link' });
      }).catch(function () {
        saveStatus.textContent = 'Copy did not work. Select the link in your address bar and copy it instead.';
      }).then(function () {
        copyLinkButton.disabled = false;
      });
    });

    root.querySelector('[data-tlb-result-list]').addEventListener('click', function (event) {
      var card = event.target.closest('[data-index]');
      var action = event.target.closest('[data-tlb-qty]');
      if (!card || !action || action.disabled) return;
      var item = state.recommendations[Number(card.dataset.index)];
      var nextQty = action.dataset.tlbQty === 'plus' ? item.qty + 1 : Math.max(1, item.qty - 1);
      if (!canSetItem(item, nextQty)) {
        cartStatus.textContent = 'That change would exceed the measured play positions or the two spare kit clips.';
        return;
      }
      item.qty = nextQty;
      cartStatus.textContent = '';
      renderRecommendationList();
    });

    root.querySelector('[data-tlb-result-list]').addEventListener('change', function (event) {
      if (!event.target.matches('[data-tlb-toggle]')) return;
      var card = event.target.closest('[data-index]');
      var item = state.recommendations[Number(card.dataset.index)];
      if (event.target.checked && !canSetItem(item, item.qty)) {
        event.target.checked = false;
        cartStatus.textContent = 'That add-on would exceed the measured play positions or the two spare kit clips.';
        return;
      }
      item.selected = event.target.checked;
      cartStatus.textContent = '';
      renderRecommendationList();
    });

    addButton.addEventListener('click', function () {
      if (addButton.disabled) return;
      var properties = cartProperties();
      var items = state.recommendations.filter(function (item) {
        return item.selected && item.product && item.product.available;
      }).map(function (item) {
        return { id: item.product.id, quantity: item.qty, properties: properties };
      });
      if (!items.length) return;
      addButton.disabled = true;
      root.querySelector('[data-tlb-add-label]').textContent = state.mode === 'accessory' ? 'Adding your accessories…' : 'Adding your system…';
      cartStatus.textContent = '';
      var addUrl = window.theme && window.theme.routes && window.theme.routes.cartAdd ? window.theme.routes.cartAdd : '/cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Unable to add this system.'); });
        return response.json();
      }).then(function () {
        cartStatus.textContent = 'Added! Taking you to your cart…';
        track('add_to_cart', { cart_method: 'builder_recommendation' }, {
          currency: currency,
          value: selectedTotal() / 100,
          items: selectedItemsPayload().map(function (item) {
            return {
              item_id: item.item_id,
              item_name: item.item_name,
              item_category: 'Trelines Builder',
              price: item.price,
              quantity: item.quantity
            };
          })
        });
        var cartUrl = window.theme && window.theme.routes && window.theme.routes.cartPage ? window.theme.routes.cartPage : '/cart';
        window.setTimeout(function () { window.location.assign(cartUrl); }, 450);
      }).catch(function (error) {
        cartStatus.textContent = error.message || 'Something went wrong. Please try again.';
        renderTotal();
      });
    });

    var savedBuild = decodeBuild();
    if (savedBuild) {
      state.mode = savedBuild.mode;
      state.answers = savedBuild.answers;
      state.buildId = savedBuild.buildId;
      state.savedItems = savedBuild.items;
      var savedFlow = getFlow();
      if (savedFlow.length && savedFlow.every(isAnswered)) {
        started = true;
        showResults();
        track('trelines_saved_build_opened', { open_method: campaign.utm_medium || 'link' });
      } else {
        state.mode = 'system';
        state.answers = {};
        state.savedItems = null;
        renderQuestion();
      }
    } else {
      renderQuestion();
    }

  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-trelines-builder]').forEach(initBuilder);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
